<template>
  <div class="agent-action-box">
    <el-dialog
      :title="`渠道号${channel} ${title}`"
      :visible.sync="dialogVisible"
      width="1650px"
      class="el-dialogs"
    >
      <div class="line" ref="regChart" style="width:1600px;height:400px"></div>
    </el-dialog>
  </div>
</template>
<script>
// import { validatorHanzi } from '@/utils/validator';
import moment from "moment";
import API from "@/api";
import echarts from "echarts";
export default {
  data() {
    return {
      // 外层弹出框
      dialogVisible: false,
      // 弹窗标题
      title: "完成率趋势图",
      data: [],
      channel: "",
      isChart: false,
    };
  },
  mounted() {},
  methods: {
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(data) {
      this.dialogVisible = true;
      this.channel = data.channel;
      this.$nextTick(() => {
        this.chartData(data);
      });
    },
    // fliterTime(num){
    //   if(num ===0){
    //     return '00:00'
    //   }
    //   if(num>60){

    //   }
    // },
    chartData(data) {
      const myChart = echarts.init(this.$refs.regChart);
      const subTit = moment(data.sumDate)
        .utcOffset(480)
        .format("YYYY年MM月DD日");
      myChart.showLoading({
        text: "拼命加载中",
        color: "#d54867",
        textColor: "#d54867",
        maskColor: "rgba(255,255,255,0.8)",
        zlevel: 0,
      });
      // 折线图数据接口
      let getLineChartData = API.getEchartData(data);
      getLineChartData
        .then((res) => {
          if (res.code == 200) {
            let time = [];
            let yesterdayIos = [];
            Object.keys(res.data).forEach((key) => {
              time.push(
                moment(key * 1000)
                  .utcOffset(480)
                  .format("HH:mm")
              );
              yesterdayIos.push(res.data[key]);
            });
            myChart.hideLoading();
            let option = {
              title: {
                text: `渠道号${this.channel} ${this.title}`,
                subtext: `${subTit}`,
              },
              tooltip: {
                trigger: "axis",
              },
              egend: {
                data: ["交易统计"],
              },
              toolbox: {
                show: true,
                feature: {
                  dataZoom: {
                    yAxisIndex: "none",
                  },
                  dataView: { readOnly: false },
                  magicType: { type: ["line", "bar"] },
                  restore: {},
                  saveAsImage: {},
                },
              },
              xAxis: {
                type: "category",
                boundaryGap: false,
                axisLabel: {
                  interval: 1,
                  rotate: 40,
                },
                data: time,
              },
              yAxis: {
                type: "value",
                axisLabel: {
                  formatter: "{value} ",
                },
              },
              series: [
                {
                  name: "交易统计",
                  type: "line",
                  data: yesterdayIos,
                  markPoint: {
                    data: [
                      { type: "max", name: "最大值" },
                      { type: "min", name: "最小值" },
                    ],
                  },
                  markLine: {
                    data: [{ type: "average", name: "平均值" }],
                  },
                },
              ],
            };
            myChart.setOption(option);
          } else {
            myChart.showLoading({
              text: "暂无数据",
              color: "#ffffff",
              textColor: "#8a8e91",
              maskColor: "rgba(255, 255, 255, 0.8)",
            });
            this.load = false;
          }
        })
        .catch(() => {
          myChart.showLoading({
            text: "暂无数据",
            color: "#ffffff",
            textColor: "#8a8e91",
            maskColor: "rgba(255, 255, 255, 0.8)",
          });
          this.load = false;
        });
      // 图表大小适应窗口尺寸,不需要可删除
      // window.onresize = function() {
      //   myChart.resize()
      // }
    },
  },
};
</script>

<style lang="scss">
.agent-action-box {
  .el-input {
    width: 220px;
  }
  .checked {
    margin-left: 10px;
  }
  .avatar-uploader {
    width: 150px;
    height: 150px;
  }
  .page-box {
    margin-top: 35px;
    position: relative;
    height: 40px;
  }
  .el-pagination {
    margin-top: 0 !important;
  }
}
</style>
